import { LoginButton } from "@src/components/LoginButton";

import "./style.less";

export function Codecs() {
  return (
    <div className="Codecs-page">
      <LoginButton />
      <div className="card">
        <img
          src="/logo.png"
          alt="Fabricca Multimídia"
          title="Fabricca Multimídia"
          className="logo"
        />
        <div className="codec">
          MP3 Codec
          <audio preload="none" crossOrigin="anonymous" controls>
            <source src="/audio_mp3.mp3" type="audio/mpeg" />
          </audio>
        </div>
        <div className="codec">
          AAC Codec
          <audio preload="none" crossOrigin="anonymous" controls>
            <source src="/audio_aac.m4a" type='audio/mp4; codecs="mp4a.40.2"' />
          </audio>
        </div>
      </div>
    </div>
  );
}
